module.exports = __webpack_public_path__ + "img/slider-2.c35b2107.jpg";